import styled from 'styled-components';

export interface LegendLabelStyledProps {
  $fontSize: number;
}

export const LegendLabelStyled = styled.div<LegendLabelStyledProps>`
  font-size: ${({ $fontSize }) => $fontSize}px;
`;
